import Tab from 'bootstrap/js/src/tab';

window.bootstrap = window.bootstrap || {};
window.bootstrap.Tab = Tab;
